/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * `ResizeObserver` polyfill for the Chromium 52 baseline.
 *
 * `ResizeObserver` is Chrome 64+. It is a host API, so neither Babel nor
 * core-js can help: on a legacy TV browser `new ResizeObserver(...)` throws
 * `TypeError: ResizeObserver is not a constructor` at the call site.
 *
 * The shared `Carousel` measures how many tiles fit its viewport with one
 * (`src/views/common/Carousel/Carousel.tsx`), so without this every screen that
 * renders a carousel — Home, MyHub, Content Detail, Player Carousel — threw
 * during its layout effect and failed to render.
 *
 * See docs/CHROMIUM-52-COMPATIBILITY.md (P1-2).
 */
import ResizeObserverPolyfill from "resize-observer-polyfill";

/**
 * Installs the polyfill only when the host does not already provide one, so
 * modern browsers keep their native implementation (which observes layout
 * directly instead of polling on a MutationObserver).
 */
export function installResizeObserver(): void {
  if (typeof window === "undefined") {
    return;
  }

  if (typeof window.ResizeObserver !== "undefined") {
    return;
  }

  window.ResizeObserver = ResizeObserverPolyfill;
}
